import { Map } from 'immutable'

import {
  SET_EMPLOYEES,
  SET_EMPLOYEE_COUNT,
  SET_MANAGER_COUNT,
  SET_LAST_UPLOAD_DATE,
  SET_RECORDS_CHANGED_COUNT,
  SET_SIMPLE_EMPLOYEES_COUNT
} from '../actions'

export const initialState = new Map({
  queryResults: [],
  employeeCount: 0,
  managerCount: null,
  lastUploadDate: null,
  recordsChangedCount: 0,
  notAdminsCount: null
})

const usersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_EMPLOYEES:
      return state.set('queryResults', action.data)
    case SET_EMPLOYEE_COUNT:
      return state.set('employeeCount', action.data)
    case SET_MANAGER_COUNT:
      return state.set('managerCount', action.data)
    case SET_LAST_UPLOAD_DATE:
      return state.set('lastUploadDate', action.data)
    case SET_RECORDS_CHANGED_COUNT:
      return state.set('recordsChangedCount', action.data)
    case SET_SIMPLE_EMPLOYEES_COUNT:
      return state.set('notAdminsCount', action.data)
    default:
      return state
  }
}

export default usersReducer
